const toastify = require('react-toastify');

exports.ToastContainer = toastify.ToastContainer;
exports.toast = toastify.toast;
